import script from "./StakingMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./StakingMenu.vue?vue&type=script&setup=true&lang=ts"

import "./StakingMenu.vue?vue&type=style&index=0&id=f71142d6&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f71142d6"]])

export default __exports__